module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/carpe_diem-56c188f47b6f856427b1ee58bf2db62f.png";